import React from 'react'
import logo from '../jpegs/4IkX0.jpg'
import "./Navbar.css"
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <div className='navbar-div'>
      <img className="navbar-logo"src={logo} alt="logo"/>
      <ul className='navbar-links'>
      <li><Link to="/home">home</Link></li>
      <li><Link to="/about">about</Link></li>
      <li><Link to="/contact">contact</Link></li>
      <li><Link to="/project">project</Link></li>
      
      </ul>
    </div>
  )
}

export default Navbar
